export type CredentialRoleLabelFields = {
  role?: string | null;
  roleId?: string | null;
};

export type CustomRoleName = {
  id: string;
  name: string;
};

export const resolveCredentialRoleLabel = ({
  credential,
  customRoles,
}: {
  credential: CredentialRoleLabelFields;
  customRoles?: ReadonlyArray<CustomRoleName>;
}): string => {
  if (credential.roleId && customRoles) {
    const customRole = customRoles.find(
      (role) => role.id === credential.roleId,
    );

    if (customRole?.name) {
      return customRole.name;
    }
  }

  return credential.role?.trim() ?? '';
};
